import{a}from"./chunk-VW2UBFJI.js";import{m as n}from"./chunk-HBP5N4FR.js";n();function T({transactions:e=[]}){return a({transactions:e})?e.flat():e}export{T as a};
//# sourceMappingURL=chunk-VH5B3W6C.js.map
